const SimulationEvent = require("./SimulationEvent");
const labourCosts = require("../../db/labour.json");
const {convert, getCheckedItems, getWageByPref, getEmployeeSalaryByPref, getPartTimehourlyWageByPref, checkFields, getKeyByOptions} = require("./helper/labour");
const labourTypes = require("../../db/labourType.json");

class Labour extends SimulationEvent {
  constructor(elements, emit, events) {
    super();
    this.elements = elements;
    this.emit = emit;
    this.events = events;
    this.inputs = {
      capacity: "",
      pref: "",
      prefId: null,
      options: []
    };
    this.totalCost = 0;
    this.index = null;
    this.init();
  }


  init() {

    super.triggerAll(this.elements);

    super.watch(this.elements.capacityEle, (e) => {
      this.inputs = {
        ...this.inputs,
        capacity: convert(e.target.value)
      }
      if (checkFields(this.inputs)) {
        this.calcTotalCost();
      }
    })


    super.watch(this.elements.prefEle, (e) => {
      const id = parseInt(e.target.value);
      const wage = getWageByPref(id);
      this.inputs = {
        ...this.inputs,
        pref: wage,
        prefId: id
      }
      if (checkFields(this.inputs)) {
        this.calcTotalCost();
      }
    })


    const checkboxes = this.elements.optionsEle.querySelectorAll(".checkbox");
    for (const checkbox of Array.from(checkboxes)) {
      super.watch(checkbox, (e) => {

        this.inputs = {
          ...this.inputs,
          options: getCheckedItems(checkboxes)
        }

        // チェックボックスが外された場合、または全て外れた場合にリセット
        if (!e.target.checked || this.inputs.options.length === 0) {
          this.resetTotalCost();
        }

        // チェックボックスがチェックされている場合は計算を実行
        if (checkFields(this.inputs)) {
          this.calcTotalCost();
        }
      })
    }
  }

  setInputs({prefEle, capacityEle, optionsEle}) {
    const prefId = parseInt(prefEle);
    this.inputs = {
      capacity: convert(capacityEle),
      pref: getWageByPref(prefId),
      prefId: prefId,
      options: optionsEle
    }


    if (checkFields(this.inputs)) {
      this.calcTotalCost();
    }
  }


  getEmployeeSalary() {
    if (this.inputs.prefId && "employeeSalary" in labourCosts) {
      const salary = getEmployeeSalaryByPref(this.inputs.prefId, this.inputs.options, this.inputs.capacity);
      return salary || 0;
    }

    // フォールバック：従来の方法
    if ("employee" in labourCosts) {
      const {price} = Array.from(labourCosts.employee)[this.index];
      return price;
    }

    return 0;
  }

  getChefSalary() {
    if ("chef" in labourCosts) {
      let {price} = Array.from(labourCosts.chef)[this.index];
      if (price === null) price = 0;
    
      return price;
    }

    return 0;
  }

  getDaysToProvide() {
    if ("partTimer" in labourCosts) {
      const {dayOfProvide} = labourCosts.partTimer[this.index];
      return dayOfProvide;
    }
    return 0;
  }

  getPartTimerSalary() {
    //提供日数
    const daysToProvide = this.getDaysToProvide();

    if ("partTimer" in labourCosts) {
      const {number, hour} = labourCosts.partTimer[this.index];

      // // 都道府県IDに基づいてパートタイム時給を取得
      const hourlyWage = this.inputs.prefId ? getPartTimehourlyWageByPref(this.inputs.prefId) : this.inputs.pref;

      // 人数 × 時間 × 時給
      const partTimehourlyWage = number * hour * hourlyWage;


      const sum = partTimehourlyWage * daysToProvide;


      return sum;
    }

    return 0;
  }

  getWelfareCost() {
    if ("welfare" in labourCosts) {
      const {
        numberOfEmployee,
        numberOfPartTimer,
        // welfare,
        // hygiene,
        // laundry,
        // stoolExamination,
        // checkupEmployee,
        // checkupPartTimer,
        companyHousing
      } = Array.from(labourCosts.welfare)[this.index];

      // 都道府県ごとの社員給与を取得
      const employeePrice = this.inputs.prefId && "employeeSalary" in labourCosts
        ? getEmployeeSalaryByPref(this.inputs.prefId, this.inputs.options, this.inputs.capacity)
        : labourCosts.employee[this.index].price;

      const chefPrice = labourCosts.chef[this.index].price;
      const chefCount = chefPrice && chefPrice > 0 ? 1 : 0;
      const totalEmployeeCount = numberOfEmployee + chefCount;


      // 基本福利厚生費
      // 旧計算式（コメントアウト）
      // const welfare = Math.round((employeePrice + chefPrice) * 0.18);
    

      // 新計算式
      const welfare = Math.round(((employeePrice + chefPrice) * 0.18));

      // 衛生管理費
      const hygiene = Math.round((totalEmployeeCount + numberOfPartTimer) * 10000 * 2 / 12);

      // 洗濯費
      const laundry = Math.round((totalEmployeeCount + numberOfPartTimer) * 500);

      // 便検査費
      const stoolExamination = Math.round((totalEmployeeCount + numberOfPartTimer) * 950);

      // 社員健診費
      const checkupEmployee = Math.round((totalEmployeeCount + 1) * 16000 / 12);

      // パートタイマー健診費
      const checkupPartTimer = Math.round((numberOfPartTimer) * 6000 / 12);

      // 会社住宅費

      const sum = welfare + hygiene + laundry + stoolExamination + checkupEmployee + checkupPartTimer + companyHousing;

      return sum;
    }

    return 0;
  }

  calcTotalCost() {

    if (!this.inputs.capacity || !this.inputs.options.length) return;
    const key = getKeyByOptions(this.inputs.options);
    if ("data" in labourTypes) {
      this.index = labourTypes.data[this.inputs.capacity][key];
      if (isNaN(this.index)) return;

      // 各要素を個別に取得
      const employeeSalary = this.getEmployeeSalary();
      const partTimerSalary = this.getPartTimerSalary();
      const chefSalary = this.getChefSalary();
      const welfareCost = this.getWelfareCost();


      this.totalCost = employeeSalary + partTimerSalary + chefSalary + welfareCost;


      this.emit("labour", this.totalCost);
    }
  }

  resetTotalCost() {
    this.totalCost = 0;
    this.emit("labour", this.totalCost);
  }

  getTotalCost() {
    if (!this.totalCost) return 0;
    return this.totalCost;
  }
}


module.exports = Labour;
